import { PartState } from '../types';

export const determinedState: PartState = {
	antenna1: {
		path: 'M156.968 66.363C155.53 57.296 156.788 37.1408 173.322 29.0563',
		tip: { cx: 174.229, cy: 28.6365, r: 4.5 },
	},
	antenna2: {
		path: 'M138.33 67.2166C136.893 58.1495 138.151 37.9943 154.684 29.9098',
		tip: { cx: 154.231, cy: 30.1199, r: 4.5 },
	},
	body: { x: 103, y: 62, width: 100, height: 162, rx: 32 },
	bodyHighlight:
		'M184 79C172.649 65.0899 142.137 61.3331 132 61C211.534 61 207.635 61 213.873 138.954C218.531 197.168 196.756 220.66 188.13 222.445C187.194 222.638 186.495 221.842 186.495 220.886C186.504 178.976 196.493 94.3093 184 79Z',
	stripes: { y1: 140, y2: 169, y3: 198, height: 15 },
	eyes: { y: 96.5, leftX: 113.435, rightX: 151.966, width: 10.4139, height: 16.6623, rx: 5.20697 },
	wing1Path:
		'M197.584 101.228L180.383 143.403C179.363 145.904 179.081 148.645 179.57 151.302C180.984 158.978 188.354 164.055 196.03 162.641L198.555 162.176C200.953 161.734 203.225 160.773 205.211 159.36L234.562 138.479C236.469 137.122 238.21 135.547 239.751 133.786L244.412 128.457C250.708 121.259 252.742 111.275 249.762 102.188C244.927 87.4468 228.721 79.7723 214.253 85.3734L213.383 85.7103C206.206 88.4888 200.491 94.1022 197.584 101.228Z',
	wing2Path:
		'M235.684 150.201L192.679 135.194C190.129 134.304 187.377 134.163 184.75 134.789C177.156 136.596 172.465 144.217 174.273 151.811L174.867 154.309C175.432 156.68 176.509 158.9 178.022 160.811L200.387 189.047C201.84 190.882 203.502 192.54 205.341 193.988L210.903 198.369C218.415 204.286 228.491 205.802 237.412 202.359C251.885 196.771 258.715 180.191 252.376 166.031L251.995 165.179C248.851 158.155 242.95 152.737 235.684 150.201Z',
	arms: [
		{ d: 'M95.4285 174.913L106.387 145.793', side: 'left' },
		{ d: 'M203.261 144.672L209.919 175.065', side: 'right' },
	],
	stinger:
		'M122.19 248.417C124.23 245.528 125.856 240.774 126.997 236.283C127.911 232.683 131.867 230.597 135.223 232.189C137.997 233.505 139.186 236.865 137.182 239.192C133.255 243.752 127.508 247.155 122.866 249.252C121.861 249.706 121.554 249.318 122.19 248.417Z',
};
